import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { RootProvider } from "./providers/RootProvider";
import { routes } from "./routes";

const router = createBrowserRouter(routes);

function App() {
  return (
    <RootProvider>
      <RouterProvider router={router} />
    </RootProvider>
  );
}

export default App;
